import Phaser from 'phaser'
import {
    CST
} from '../CST'

export default class RulesScene1 extends Phaser.Scene {
    constructor() {
        super(CST.SCENES.RULES1)
    }

    preload() {}

    create(data) {

        var click = this.sound.add("clickSound");

        this.scene.bringToTop();

        this.add.image(this.cameras.main.width / 2, this.cameras.main.height / 2, 'rules1');

        this.add.image(this.cameras.main.width / 2, (this.cameras.main.height / 2) + 397, 'btn_back').setScale(0.7).setInteractive({
            useHandCursor: true
        }).on("pointerdown", () => {
            click.play();
            this.scene.stop();
            this.scene.resume(data.scene, {
                type: 5
            });
        })

        this.add.image(this.cameras.main.width / 2 + 600, (this.cameras.main.height / 2) - 350, 'btn_forward').setInteractive({
            useHandCursor: true
        }).on("pointerdown", () => {
            click.play();
            this.scene.sendToBack();
            this.scene.stop();
            this.scene.start(CST.SCENES.RULES2, {
                scene: data.scene
            });
        })
    }
}